import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/pages/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js